import React, { useEffect } from "react";
import { connect } from "react-redux";

import { getWebsocketUrl } from "../apiConfiguration";
import { AppDispatch } from "../App";
import Snackbar from "../components/Snackbar";
import { Websocket, socketConnect, socketDisconnect } from "../state/websockets";

import heightWidthStyles from "./../styles/HeightWidth.module.css";
import SelectScenario from "./SelectScenario";
import StartScreenBackground from "./StartScreenBackground";

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

const StartScreen: React.FC<PropsFromDispatch> = (props) => {
  const { activeSimulationsConnect, activeSimulationsDisconnect } = props;

  useEffect(() => {
    // Connect to active-simulations websocket at start screen
    activeSimulationsConnect();

    // Return a function that will be run at component unmount, to
    // disconnect again.
    return activeSimulationsDisconnect;
  }, [activeSimulationsConnect, activeSimulationsDisconnect]);

  return (
    <div className={heightWidthStyles.Full}>
      <StartScreenBackground>
        <Snackbar />
        <SelectScenario />
      </StartScreenBackground>
    </div>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    activeSimulationsConnect: () =>
      dispatch(socketConnect(getWebsocketUrl("active-simulations/"), Websocket.ActiveSimulations)),
    activeSimulationsDisconnect: () => {
      console.log("activeSimulationsDisconnect");
      dispatch(socketDisconnect(Websocket.ActiveSimulations));
    },
  };
};

export default connect(null, mapDispatchToProps)(StartScreen);
